// extracted by mini-css-extract-plugin
export default {"radius":"CompanyBasicInformaion_radius__-fUv+"};